export default __webpack_public_path__ + "static/media/mascote-corpo.f3a51a09.webp";